import { render } from "./customer-reset-password.vue?vue&type=template&id=5c809245&scoped=true"
import script from "./customer-reset-password.vue?vue&type=script&lang=js"
export * from "./customer-reset-password.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5c809245"

export default script